import { render, staticRenderFns } from "./head_whole.vue?vue&type=template&id=7a4a7fde&scoped=true&"
import script from "./head_whole.vue?vue&type=script&lang=js&"
export * from "./head_whole.vue?vue&type=script&lang=js&"
import style0 from "./head_whole.vue?vue&type=style&index=0&id=7a4a7fde&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4a7fde",
  null
  
)

export default component.exports